<template>
   <div class="weblink-container mp-asset-container" :class="{active: isActive}">
      <div class="weblink-wrapper mp-asset-wrapper" @click="handleClickAsset">
         <div class="weblink-filename mp-filename">
            <div v-if="asset.c_desc1 !== '' && asset.c_desc1 !== null">{{asset.c_desc1}}</div>
            <div v-else-if="asset.c_name !== '' && asset.c_name !== null">{{asset.c_name}}</div>
            <div v-else >{{asset.c_filename}}</div>
         </div>
         <div>
            <div class="btn-info-container">
               <button class="btn-info" v-click-outside="hide" @keyup.esc="hide" @click.self="toggleShowmeta(), toggleSelected()" :class="{ selected: isSelected }"></button>
            </div>
            <transition name="meta-data-transition">
               <div class="meta-data-container" v-if="showMetadata">
                  
                  <m-p-meta-data
                     :assetRecid="asset.recid"
                     :assetType="assetType"
                  >
                  </m-p-meta-data>

                  <!-- <button class="btn-media-lib">Show in Media Library</button> -->

               </div>
            </transition>
         </div>
      </div>
   </div>
</template>

<script>
import MPAsset from './MPAsset';

export default {
   extends: MPAsset,

   props: {
      playingIndex: Number //index of the asset playing
   }
}
</script>